<template>
  <div id="app-center">
    <home-head></home-head>
    <home-nav></home-nav>
    <div class="center-box">
      <div class="center-list">
        <h3>志愿者申请</h3>
        <div class="center-left"
             style="padding-top: 0">
          <el-form ref="applyForm"
                   :model="form"
                   :rules="ruleValidate"
                   label-width="130px">
            <el-alert :title="cueTitle"
                      :type="cueType"
                      :description="cueDesc"
                      :closable="false"
                      show-icon
                      v-if="form.audit_status >=0"></el-alert>
            <table class="table">
              <tr>
                <td colspan="2"
                    class="sort-box">
                  <h3>基础信息</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="姓名："
                                prop="user_name">
                    <el-input v-model="form.user_name"
                              style="width: 80%"
                              size="small"
                              :maxlength="40"
                              placeholder="请输入申请者姓名"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td rowspan="3">
                  <el-form-item label
                                style="text-align:center;margin-right:150px">
                    <el-upload class="avatar-uploader"
                               ref="headImgRef"
                               :action="uploadImgUrl"
                               :show-file-list="false"
                               :on-success="onSuccess"
                               :data="{file_type: 2}"
                               :file-list="defImg"
                               name="img"
                               :before-upload="beforeUpload">
                      <img v-if="imageUrl"
                           :src="imageUrl"
                           class="avatar" />
                      <i v-else
                         class="el-icon-plus avatar-uploader-icon">上传寸照</i>
                    </el-upload>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="身份证号码："
                                prop="user_cardno">
                    <el-input v-model="form.user_cardno"
                              style="width: 80%"
                              size="small"
                              ref="idCard"
                              placeholder="请输入身份证号码"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="性别："
                                prop="user_sex">
                    <el-radio-group v-model="form.user_sex">
                      <el-radio :label="1">男</el-radio>
                      <el-radio :label="2">女</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="出生日期："
                                prop="birthday">
                    <el-date-picker v-model="form.birthday"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    size="small"
                                    style="width: 80%"
                                    placeholder="选择日期"></el-date-picker>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="志愿者类型"
                                prop="ifunit">
                    <el-radio v-model="form.ifunit"
                              :label="1">企业志愿者</el-radio>
                    <el-radio v-model="form.ifunit"
                              :label="2">非企业志愿者</el-radio>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="工作单位：">
                    <el-input :maxlength="200"
                              v-model="form.comany"
                              style="width: 80%"
                              size="small"
                              placeholder="请输入工作单位"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="民族：">
                    <el-select v-model="form.nation"
                               size="small"
                               placeholder="请选择民族"
                               style="width: 80%">
                      <el-option v-for="item in nationData"
                                 :key="item.id"
                                 :label="item.nation_name"
                                 :value="item.id"></el-option>
                    </el-select>

                    <!-- <el-input
                      v-model="form.nation"
                      style="width: 80%"
                      size="small"
                      placeholder="请输入民族"
                      suffix-icon="el-icon-edit"
                    ></el-input>-->
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="政治面貌：">
                    <el-input :maxlength="10"
                              v-model="form.political_status"
                              style="width: 80%"
                              size="small"
                              placeholder="请输入政治面貌"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="籍贯："
                                prop="birthplace">
                    <el-input :maxlength="20"
                              v-model="form.birthplace"
                              style="width: 80%"
                              size="small"
                              placeholder="请输入籍贯"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="专业/职业：">
                    <el-input :maxlength="100"
                              v-model="form.profession"
                              style="width: 80%"
                              size="small"
                              placeholder="请输入专业/职业"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>

                <!-- <td>
                      <el-form-item label="学历：">
                        <el-input
                          v-model="form.education_experience"
                          style="width: 80%"
                          size="small"
                          placeholder="请输入学历"
                          suffix-icon="el-icon-edit"
                        ></el-input>
                      </el-form-item>
                </td>-->
              </tr>
              <tr>
                <td colspan="2"
                    class="sort-box">
                  <h3>联系方式</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <el-form-item label="联系方式："
                                prop="mobile">
                    <el-input :maxlength="11"
                              v-model="form.mobile"
                              style="width: 80%"
                              size="small"
                              placeholder="请输入手机号码"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="电子邮箱："
                                prop="email">
                    <el-input :maxlength="30"
                              v-model="form.email"
                              style="width: 80%"
                              size="small"
                              placeholder="请输入电子邮箱"
                              suffix-icon="el-icon-edit"></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <el-form-item label="居住城市："
                                prop="province_id">
                    <el-select v-model="form.province_id"
                               size="small"
                               placeholder="请选择省份"
                               style="width: 30%"
                               @change="getCity"
                               :popper-append-to-body="false">
                      <el-option v-for="item in provinceList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="form.city_id"
                               size="small"
                               ref="city"
                               placeholder="请选择城市"
                               style="width: 30%"
                               @change="getCounty"
                               :clearable="true"
                               :popper-append-to-body="false">
                      <el-option v-for="item in cityList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                    <el-select @change="changeCountry"
                               v-model="form.county_id"
                               size="small"
                               ref="county"
                               placeholder="请选择县/区"
                               style="width: 30%"
                               :clearable="true"
                               :popper-append-to-body="false">
                      <el-option v-for="item in countyList"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr v-if="form.ifunit==1 && specificHospital.length>0">
                <td colspan="2">
                  <el-form-item label="具体执行机构："
                                prop="unit_id">
                    <el-select v-model="form.unit_id"
                               :popper-append-to-body="false"
                               clearable
                               style="width: 91%"
                               placeholder="请选择具体的执行机构">
                      <el-option v-for="item in specificHospital"
                                 :key="item.id"
                                 :label="item.unit_name"
                                 :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <el-form-item label="联系地址："
                                prop="address">
                    <el-input :maxlength="500"
                              v-model="form.address"
                              style="width: 91%"
                              size="small"
                              placeholder="请输入详细地址"
                              suffix-icon="el-icon-edit"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <!-- <tr>
                <td>
                  <el-form-item label="邮政编码：">
                    <el-input
                      v-model="form.zipcode"
                      style="width: 80%"
                      size="small"
                      placeholder="请输入邮政编码"
                    ></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item label="QQ：">
                    <el-input
                      v-model="form.qqno"
                      style="width: 80%"
                      size="small"
                      suffix-icon="el-icon-edit"
                      placeholder="请输入QQ号码"
                    ></el-input>
                  </el-form-item>
                </td>
              </tr>-->
              <tr>
                <td colspan="2"
                    class="sort-box">
                  <h3>拓展信息</h3>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <el-form-item label="教育背景：">
                    <el-input :maxlength="8000"
                              type="textarea"
                              style="width: 91%"
                              v-model="form.education_experience"
                              placeholder="请输入您的教育背景"
                              :autosize="{ minRows: 2, maxRows: 4}"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <el-form-item label="工作经历：">
                    <el-input :maxlength="8000"
                              type="textarea"
                              style="width: 91%"
                              v-model="form.work_experience"
                              placeholder="请输入工作经历"
                              :autosize="{ minRows: 2, maxRows: 4}"
                              onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr v-for="(item,index) in skillList"
                  :key="index">
                <td colspan="2"
                    v-show="item.children.length>0">
                  <el-form-item>
                    <span slot="label">
                      <span style="color:red"
                            v-if="item.ifempty == 1">*</span>
                      {{item.skill_name+'：'}}
                    </span>
                    <el-checkbox-group v-model="skills[index]">
                      <el-checkbox v-for="val in item.children"
                                   :key="val.id"
                                   :label="val.id">{{val.skill_name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </td>
              </tr>

              <tr class="service-box1">
                <td colspan="2">
                  <el-form-item label="您是否参加过类似的志愿者服务：">
                    <el-radio-group v-model="form.ifvolunteer">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </td>
              </tr>

              <tr v-if="form.ifvolunteer == 1">
                <td colspan="2">
                  <el-form-item label="个人简历">
                    <el-input :maxlength="1000"
                              type="textarea"
                              style="width: 91%"
                              v-model="form.volunteer_describ"
                              placeholder="请填写社会兼职、参加志愿服务经历、所获荣誉等"
                              :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td colspan="2"
                    class="checkBox">
                  <div class="check-box">
                    <el-checkbox v-model="agreeChecked">我已阅读并同意</el-checkbox>
                    <span @click="getMask">《志愿者暂行管理办法》</span>
                  </div>

                  <el-button type="primary"
                             :disabled="btnDisabled"
                             style="background-color:#ccc;border-color:#ccc"
                             v-if="btnDisabled">您已成为志愿者</el-button>
                  <el-button type="primary"
                             @click="submitForm()"
                             v-else
                             :loading="loading">提交</el-button>
                </td>
              </tr>
            </table>
          </el-form>
        </div>
      </div>
      <!-- <div class="center-footer">
        <div class="footer-content">
          <span>（建议您使用IE9及以上版本浏览器访问本网站）</span>
          <span>技术支持：长沙普益云软件科技有限公司</span>
        </div>
      </div>-->
    </div>
    <div class="mask-box"
         v-show="maskShow">
      <div class="content-box">
        <i @click="maskHidden">×</i>
        <div class="scoll-box"
             v-html="volunteerAg"></div>
      </div>
    </div>
    <home-foot></home-foot>
  </div>
</template>
<script>
import Axios from "axios";
import baseUrl from "@/config/index";
import homeHead from "../Public/head";
import homeNav from "../Public/nav";
import homeFoot from "../Public/foot";
export default {
  components: {
    homeHead,
    homeNav,
    homeFoot
  },
  data () {
    var checkUserCardno = (rule, value, callback) => {
      if (!value) {
        return callback();
      }

      var isValid = true;
      var cityCode = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      var rFormat = /^\d{6}(19|20)\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$|^\d{6}\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}$/; // 格式验证

      if (!rFormat.test(value) || !cityCode[value.substr(0, 2)]) {
        isValid = false;
      }
      // 18位身份证需要验证最后一位校验位
      else if (value.length === 18) {
        var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
        var Ci = "10X98765432"; // 校验字符
        // 加权求和
        var sum = 0;
        for (var i = 0; i < 17; i++) {
          sum += value.charAt(i) * Wi[i];
        }
        // 计算校验值
        var C17 = Ci.charAt(sum % 11);
        // 与校验位比对
        if (C17 !== value.charAt(17)) {
          isValid = false;
        }
      }
      if (!isValid) {
        return callback(new Error("请填写正确的身份证号码！"));
      } else {
        this.handleInfoReader();
        return callback();
      }
    };
    var checkDistinct = (rule, value, callback) => {
      if (
        this.form.city_id == null ||
        this.form.city_id == "" ||
        typeof this.form.city_id == "undefined" ||
        this.form.county_id == null ||
        this.form.county_id == "" ||
        typeof this.form.county_id == "undefined"
      ) {
        return callback(new Error("请选择地址"));
      }
      return callback();
    };
    return {
      loading: false,
      imageUrl: null,
      defImg: [],
      uploadImgUrl: "", //上传图片接口url
      provinceList: [],
      cityList: [],
      countyList: [],
      volunteerAg: "", //协议内容
      agreeChecked: true, //协议勾选
      btnDisabled: false, //提交按钮状态
      maskShow: false, //协议框
      // mustIds:[],

      //志愿者申请状态提示相关
      cueTitle: "",
      cueType: "info",
      cueDesc: "",
      validateIds: [],
      skills: [],
      nationData: [], //民族使用字典
      specificHospital: [], //具体执行机构
      form: {
        unit_id: null, //具体执行机构
        ifunit: 1, //是否为企业
        user_name: "", //姓名
        user_sex: 1, //性别
        user_cardno: "", //身份证号
        birthday: "", //出生年月
        profession: "", //职业
        education_experience: "", //学历
        comany: "", //单位、学校
        nation: "", //民族
        birthplace: "", //籍贯
        political_status: "", //政治面貌
        mobile: "", //联系方式
        email: "", //邮箱
        province_id: null, //省
        city_id: null, //市
        county_id: null, //县
        address: "", //联系地址
        zipcode: "", //邮政编码
        qqno: "", //qq号码
        work_experience: "", //工作经历
        volunteer_describ: "", //志愿者描述
        ifvolunteer: 1, //是否参加过志愿者活动
        skills: [],
        validateSkill: [{ value: "" }]
      },
      skillList: [], //志愿者技能

      ruleValidate: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        province_id: [
          { required: true, message: "请选择地址", trigger: "change" },
          { validator: checkDistinct, trigger: "change" }
        ],
        birthplace: [
          { required: true, message: "请输入籍贯！", trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入联系人电话长度为11",
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "请输入电子邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" }
        ],
        address: [
          { required: true, message: "请输入联系地址", trigger: "blur" }
        ],
        user_sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择出生年月", trigger: "blur" }
        ],
        user_cardno: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
          { validator: checkUserCardno, trigger: "blur" }
        ],
        validateSkill: [{ value: "" }],
        ifunit: [
          { required: true, message: "请选择志愿者类型", trigger: "change" }
        ]
        // unit_id:[
        //   {required:true,message:'请选择具体执行机构',trigger:'change'}
        // ]
      }
    };
  },
  methods: {
    onSuccess (response, file, fileList) {
      this.imageUrl = response.data.imgPath;
      this.form.header_id = response.data.id;
    },

    beforeUpload (file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    getMask () {
      this.maskShow = true;

      this.$db
        .post(this.$db.config.getVolunteerAgreement, { type: 3 })
        .then(res => {
          if (res.code == 200) {
            this.volunteerAg = res.data;
          }
        });
    },
    maskHidden () {
      this.maskShow = false;
    },
    goto (name) {
      this.$router.push({ name: name });
    },

    getCity (value, isEdit = false) {
      if (!isEdit) {
        this.form.city_id = null;
        this.form.county_id = null;
      }
      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.cityList = resp.data;
          }
        });
      this.getHospitalByAddress(
        this.form.province_id,
        this.form.city_id,
        this.form.county_ids,
        isEdit
      );
    },
    getCounty (value, isEdit = false) {
      if (!isEdit) {
        this.form.county_id = null;
      }
      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.countyList = resp.data;
          }
        });
      this.getHospitalByAddress(
        this.form.province_id,
        this.form.city_id,
        this.form.county_id,
        isEdit
      );
    },
    changeCountry () {
      this.getHospitalByAddress(
        this.form.province_id,
        this.form.city_id,
        this.form.county_id
      );
    },
    // 读取身份证相关信息，并自动填充
    handleInfoReader () {
      // 渲染省市县、生日、性别、籍贯等信息
      let cardno = this.form.user_cardno;

      this.form.user_cardno = this.form.user_cardno.replace(/^ +| +$/g, "");
      if (cardno.length === 18) {
        // 省市县渲染
        let province = cardno.substring(0, 2) + "0000";
        let city = cardno.substring(0, 4) + "00";
        let county = cardno.substring(0, 6);

        // 出生年月
        let year = cardno.substring(6, 10);
        let month = cardno.substring(10, 12);
        let day = cardno.substring(12, 14);
        let birthday = year + "-" + month + "-" + day;
        this.$set(this.form, "birthday", birthday);

        // 性别
        let sex = cardno.substring(16, 17);
        this.$set(this.form, "user_sex", Number(sex) % 2 == 0 ? 2 : 1);
      }
    },
    getVal (val) {
    },
    getVolunteerInfo () {
      this.$db
        .post(this.$db.config.getVolunteerSkill, { tree_type: 2 })
        .then(res => {
          //获取技能
          if (res.code == 200) {
            this.skillList = res.data;
            for (let key in this.skillList) {
              //组装绑定技能变量数组
              this.$set(this.skills, key, []);
            }
          }
        });

      this.$db.post(this.$db.config.getVolunteerDetails, {}).then(res => {
        //获取基本信息
        if (res && res.code == 200) {
          this.form = res.data;
          if (!(res.data.id > 0)) {
            this.$set(this.form, "user_sex", 1);
            this.$set(this.form, "ifunit", 2);
            this.$set(this.form, "ifvolunteer", 1);
            this.$set(this.form, "province_id", null);
            this.$set(this.form, "city_id", null);
            this.$set(this.form, "county_id", null);
            this.$set(this.form, "unit_id", null);
            this.$set(this.form, "birthday", "");
          } else {
            // this.getHospitalByAddress(
            //   res.data.province_id,
            //   res.data.unit_id,
            //   res.data.county_id,
            //   true
            // );
          }
          this.$set(this.form, "unit_id", Number(res.data.unit_id));

          let skills = [];
          if (!res.data.skills) {
            skills = [];
          } else {
            //选中多选框技能
            skills = res.data.skills;
            if (skills.length > 0) {
              for (let key in this.skillList) {
                for (let index = 0; index < skills.length; index++) {
                  if (
                    this.skillList[key].children.find(
                      item => item.id == skills[index]
                    )
                  ) {
                    this.$set(this.skills[key], index, skills[index]);
                  }
                }
              }
            }
          }

          if (res.data.province_id && res.data.city_id) {
            this.getCity(res.data.province_id, true);
            this.getCounty(res.data.city_id, true);

            this.$set(this.form, "province_id", res.data.province_id);
            this.$set(this.form, "city_id", res.data.city_id);
            this.$set(this.form, "county_id", res.data.county_id);

            if (Number(res.data.nation) > 0) {
              this.$set(this.form, "nation", Number(res.data.nation));
            } else {
              this.form.nation = "";
            }
          }

          switch (res.data.audit_status) {
            case 0:
              this.cueTitle = "待审核";
              this.cueType = "warning";
              this.cueDesc = "您的信息已提交，请耐心等待审核结果~";
              break;
            case 1:
              this.cueTitle = "通过审核";
              this.cueType = "success";
              this.cueDesc = "恭喜您，成功加入志愿者大家庭~";
              this.btnDisabled = true;
              break;
            case 2:
              this.cueTitle = "审核不通过";
              this.cueType = "error";
              this.cueDesc = "很抱歉，您的信息已被驳回。您还可以再次提交审核~";
              break;
            case 3:
              this.cueTitle = "审核拒绝";
              this.cueType = "error";
              this.cueDesc = "很抱歉，您的信息已被驳回。感谢您的参与~";
              this.btnDisabled = true;
              break;
          }
        }
      });
    },

    judeLogin () {
      let loginInfo = sessionStorage.getItem("token");

      if (loginInfo && loginInfo != "null") {
        //已登录
        sessionStorage.removeItem("backUrl");
        this.getVolunteerInfo();
      } else {
        //未登录
        this.$confirm("系统检测到您暂未登录, 是否进行登录?", "登录提示", {
          confirmButtonText: "立即登录",
          cancelButtonText: "返回页面",
          type: "warning"
        })
          .then(() => {
            sessionStorage.setItem("backUrl", this.$route.fullPath);
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            this.$router.push({ path: "/" });
            sessionStorage.removeItem("bread1");
            sessionStorage.removeItem("index");
          });
      }
    },

    //获取技能中必填的选项id
    // getMustIdArr(info){
    //   let arr = []
    //   info.forEach(function(item){
    //     if(item.ifempty == 1){
    //       item.children.forEach(function(val){
    //         arr.push(val.id)
    //       })
    //     }
    //   })
    //   this.mustIds = arr
    // },

    //提交申请
    submitForm () {
      this.loading = true;
      if (this.skills.length > 0) {
        let skills = [];
        skills = [].concat.apply([], this.skills); //转为一维数组
        this.form.skills = skills.filter(d => d); //去掉空值
      }

      if (!sessionStorage.getItem("token")) {
        this.judeLogin();
      }

      if (!this.agreeChecked) {
        this.$message({
          type: "error",
          message: "请先阅读并且同意志愿者协议！"
        });
        this.loading = false;
        return false;
      }
      this.$refs["applyForm"].validate(valid => {
        if (valid) {
          let url = "";
          if (this.form.id) {
            url = this.$db.config.editVolunteer;
          } else {
            url = this.$db.config.addVolunteer;
          }
          this.$db.post(url, this.form).then(res => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message({
                type: "success",
                duration: 1000,
                message: res.msg,
                onClose: function () {
                  setTimeout(location.reload(), 500);
                }
              });
            }
          }); //获取技能
        } else {
          this.loading = false;
          this.$message({
            type: "error",
            message: "请填写完整申请信息！"
          });
        }
      });
    },

    //根绝省市县 获取具体的执行机构
    getHospitalByAddress (
      $province_id = "",
      $city_id = "",
      $county_id = "",
      if_edit = false
    ) {

      if (!if_edit) {
        this.$set(this.form, "unit_id", null);
      }

      let params = {};
      params.province_id = $province_id;
      params.city_id = $city_id;
      params.county_id = $county_id;
      this.$db.post(this.$db.config.getHospitalByAddress, params).then(res => {
        if (res.code == 200) {
          this.specificHospital = res.data;
        }
      });
    }
  },
  mounted () {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.judeLogin();

    sessionStorage.setItem("crumbs", "志愿者申请");

    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceList = resp.data;
      }
    });

    this.getCity(this.form.province_id);

    //民族使用字段
    this.$db.post(this.$db.config.getNationList, {}).then(res => {
      this.nationData = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  background-color: #f1f1f1;
  border: 1px solid #eee;
}
.inputBox {
  border: none;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #eee;
  outline: none;
  padding: 6px;
  color: #666;
}
.center-box {
  margin-bottom: 100px;
  margin-top: 40px;
  .center-list {
    max-width: 1200px;
    margin: 0 auto;
    > h3 {
      font-size: 20px;
      padding: 22px 0;
      text-align: center;
      background-color: #fff;
      border-bottom: 1px solid #eee;
    }
    .center-left {
      background-color: #fff;
      width: 100%;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 14px;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .checkBox {
    position: relative;
    text-align: center;
    .check-box {
      text-align: center;
      margin-top: 20px;
      > span {
        color: #b60205;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .el-button--primary {
      background-color: #b60205;
      border-color: #b60205;
      margin: 20px 0;
    }
  }

  .comBox {
    > h3 {
      font-size: 18px;
      font-weight: normal;
      color: #333;
      text-align: center;
      padding: 12px 0;
    }
    > p {
      font-size: 16px;
      color: #666;
      padding: 12px 0;
      padding-left: 160px;
    }
    .perBox {
      padding: 12px 0;
      padding-bottom: 20px;
      text-align: right;
      font-size: 16px;
      color: #666;
      > input {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        border-bottom: 1px solid #eee;
        padding: 12px 8px;
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
  .table {
    width: calc(100% - 60px);
    margin: 20px 25px;
    > tr {
      .sort-box {
        > h3 {
          font-size: 18px;
          color: #333;
          padding: 12px 8px;
          background-color: #eee;
          width: calc(100%-16px);
          font-weight: normal;
        }
      }
    }
  }
  .table td {
    width: 50%;
    border-bottom: 1px dashed #eee;
  }
  .register_head {
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 14px;
    font-weight: 600;
    // font-family: "微软雅黑";
    color: DimGray;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    margin-right: 20px;
    //margin-bottom: 30px;
    .login {
      font-size: 12px;
      float: right;
      font-family: "微软雅黑";
      font-weight: 300;
      color: #ccc;
    }
  }
}
.mask-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background: rgba(0, 0, 0, 0.8);
  .content-box {
    max-width: 1120px;
    margin: 5% auto;
    background-color: #fff;
    height: 80%;
    position: relative;
    padding: 0 40px;
    overflow: hidden;
    > i {
      position: absolute;
      top: 6px;
      right: 20px;
      color: #333;
      font-size: 50px;
      cursor: pointer;
    }
    .scoll-box {
      padding: 0 80px;
      margin: 5% 0;
      height: 85%;
      overflow-y: scroll;
      > h3 {
        font-size: 20px;
        color: #000;
        text-align: center;
        padding: 20px;
      }
      > h5 {
        font-size: 18px;
        color: #333;
        text-align: center;
        padding: 20px;
      }
      > h6 {
        font-size: 18px;
        color: #333;
        text-align: right;
        padding: 20px;
      }
      > p {
        font-size: 16px;
        color: #666;
        line-height: 30px;
        margin-bottom: 20px;
      }
    }
    .scoll-box::-webkit-scrollbar {
      display: none;
    }
  }
}
.service-box /deep/ .el-form-item__content {
  margin-left: 200px !important ;
}
.service-box /deep/ .el-form-item__label {
  width: 200px !important;
  margin-top: 4px;
  text-align: center;
}
.service-box1 /deep/ .el-form-item__content {
  margin-left: 240px !important ;
}
.service-box1 /deep/ .el-form-item__label {
  width: 240px !important;
  margin-top: 4px;
  text-align: center;
}
.center-box /deep/ .el-steps--simple {
  padding: 22px 8%;
  background-color: #eee;
}
.center-box /deep/ .el-form-item {
  margin-bottom: 0;
  margin: 12px 0;
}
.center-box /deep/ .el-input__inner:focus {
  border-color: #b60205;
}
.center-box /deep/ .el-textarea__inner:focus {
  border-color: #b60205;
}
.center-box /deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #b60205;
}
.center-box /deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #b60205;
  background: #b60205;
}
.center-box /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #b60205;
}
.center-box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #b60205;
  background: #b60205;
}
.center-box /deep/ .el-checkbox__inner:hover {
  color: #b60205;
}
</style>

<style>
.avatar-uploader .el-upload {
  padding: 2px;
  border: 1px dashed #d9d9d9;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 16px;
  color: #8c939d;
  width: 147.5px;
  height: 206.5px;
  line-height: 206.5px;
  text-align: center;
}
.avatar {
  width: 147.5px;
  height: 206.5px;
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/Volunteer/volunteer_apply.vue